/* Anatomi: nokta ↔ not eşleşmesi. Tek seferde tek not açık kalır —
   hepsi birden açılırsa liste duvara döner. */
(() => {
  const kur = (kok) => {
    if (kok.dataset.atlReady === "1") return;
    kok.dataset.atlReady = "1";
    const pinler = [...kok.querySelectorAll("[data-atl-pin]")];
    const notlar = [...kok.querySelectorAll("[data-atl-note]")];
    if (!pinler.length) return;

    const ac = (i) => {
      notlar.forEach((n, k) => n.classList.toggle("is-open", k === i));
      pinler.forEach((p, k) => p.setAttribute("aria-expanded", k === i ? "true" : "false"));
    };
    const kapat = () => {
      notlar.forEach((n) => n.classList.remove("is-open"));
      pinler.forEach((p) => p.setAttribute("aria-expanded", "false"));
    };
    const degistir = (i) => {
      const acik = notlar[i] && notlar[i].classList.contains("is-open");
      acik ? kapat() : ac(i);
    };

    pinler.forEach((p, i) => p.addEventListener("click", () => degistir(i)));
    kok.querySelectorAll("[data-atl-jump]").forEach((b, i) =>
      b.addEventListener("click", () => degistir(i))
    );
    kok.addEventListener("keydown", (e) => { if (e.key === "Escape") kapat(); });

    // İlk not açık başlar: sayfa "tıklamadan önce boş" görünmesin.
    ac(0);
  };
  const baslat = () => document.querySelectorAll("[data-atl-anatomi]").forEach(kur);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", baslat, { once: true });
  else baslat();
  document.addEventListener("shopify:section:load", baslat);
})();
